module.exports = __webpack_public_path__ + "static/media/1POLICY27.85bc40b6.jpg";